/** IXD 편집기 mutation key 상수 - useIsMutating 구독용으로 헤더/콘텐츠 뷰가 공유 */

export const ixdEditorSaveMutationKey = (reportId: string) =>
  ["ixdEditor", reportId, "save"] as const;

export const ixdEditorDownloadMutationKey = (reportId: string) =>
  ["ixdEditor", reportId, "download"] as const;
